<template lang="pug">
.root
  .file-upload(:class="{'highlighted': highlighted, 'existing': existing && !highlighted}")
    template(v-if="!existing && !noText")
      .upload {{ $t('poster.upload_file') }}
    input(type="file", title=" ", @click="inputClick", @change="fileEvent($event.target.files)", @dragenter="highlight", @dragleave="highlight(false)")
  template(v-if="useUnsplash")
    //modal(name="unsplash", :classes="['unsplash-modal', unsplash.choosing ? 'unsplash-modal-disable' : null]")
    portal(to="modals")
      Modal(:show="unsplashModal", @close="toggleUnsplashModal(false)" :title="$t('poster.find_on_unsplash')").unsplashModal
        form(@submit.prevent="").p-a-4
          FormInput(type="text", @input="searchUnsplashText($event)" :placeholder="$t('poster.search_unsplash')").f-w
        .modal-content(:class="{'center': unsplash.loading}")
          template(v-if="unsplash.loading")
            i.mdi.mdi-magnify
            p.state-text {{ $t('upload.searching_unsplash')}}..
          .unsplash-result(v-else)
            .unsplash-image(v-for="image in unsplash.searchResult.results", @click="selectUnsplashImage($event, image)")
              img(:src="image.urls.thumb")
              small {{ $t('fileupload.photo_by') }}&nbsp;
                a(:href="`https://unsplash.com/@${image.user.username}?utm_source=streamify&utm_medium=referral`", target="_blank") {{ image.user.name }}&nbsp;
                | {{ $t('fileupload.on') }}&nbsp;
                a(href="https://unsplash.com?utm_source=streamify&utm_medium=referral", target="_blank") Unsplash
          .unsplash-pagination(v-if="unsplash.searchResult.results.length > 0 && !unsplash.loading")
            small(v-if="unsplash.currentPage > 1 && unsplash.searchResult.results.length > 0", @click="prevUnsplashPage").mr-a {{ $t('fileupload.prev_page') }}
            small(v-if="unsplash.currentPage < unsplash.searchResult.total_pages", @click="nextUnsplashPage").ml-a {{ $t('fileupload.next_page') }}
</template>

<script>

export default {
  props: {
    uploadState: {
      type: String,
      validator: value => ['', 'error', 'success', 'uploading', 'unload'].indexOf(value) !== -1,
    },
    useUnsplash: {
      type: Boolean,
      default: false,
    },
    existing: {
      type: String,
      required: false,
    },
    maxSize: {
      type: Number,
      required: false,
      default: 8,
    },
    largeFile: {
      type: Boolean,
      default: false,
    },
    validFormats: {
      type: Array,
      required: false,
    },
    noText: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /**
     * Return a backgroundimage-style if existing is set
     * @return {?String}
     */
    existingStyle() {
      const { existing } = this;
      if (!existing) return null;
      return `background-image: url(${existing})`;
    },
  },
  methods: {
    searchUnsplashText(search) {
      this.unsplash.search = search;
      if (search === '') {
        this.unsplash.searchResult.results = [];
        this.unsplash.currentPage = 1;
        this.unsplash.searchResult.total = 0;
        this.unsplash.searchResult.total_pages = 0;
        return;
      }

      clearTimeout(this.unsplash.searchTimer);
      this.unsplash.searchTimer = setTimeout(() => {
        this.searchUnsplash();
      }, 600);
    },
    /**
     * Select a image from unsplash, download it and send it to posterinput
     * @param {Object} event
     * @param {Object} image
     */
    async selectUnsplashImage(event, image) {
      if (this.unsplash.choosing) return;
      if (event.target.tagName.toLowerCase() === 'a') return;

      this.unsplash.choosing = true;

      const { data } = await ovpFetch(`${image.links.download_location}&client_id=${this.unsplashKey}`, {
        noAuth: true,
        noExtraHeaders: true,
        // headers: {
        //  Authorization: `Client-ID ${this.unsplash.key}`,
        // },
      }).catch(() => false);

      if (!data) return;

      const { data: imageResponse } = await ovpFetch(`${data.url}&client_id=${this.unsplashKey}`, {
        responseType: 'blob',
        noAuth: true,
        noExtraHeaders: true,
        // headers: {
        //  Authorization: `Client-ID ${this.unsplash.key}`,
        // },
      }).catch(() => false);

      if (!imageResponse) {
        this.unsplash.choosing = false;
        return;
      }

      this.fileEvent([imageResponse]);
      this.toggleUnsplashModal(false);
      this.unsplash.choosing = false;
    },
    nextUnsplashPage() {
      const { currentPage } = this.unsplash;
      this.unsplash.currentPage = currentPage + 1;
      this.searchUnsplash();
    },
    prevUnsplashPage() {
      const { currentPage } = this.unsplash;
      this.unsplash.currentPage = currentPage - 1;
      this.searchUnsplash();
    },
    async searchUnsplash() {
      this.unsplash.loading = true;

      const { data } = await ovpFetch(`https://api.unsplash.com/search/photos?client_id=${this.unsplashKey}&page=${this.unsplash.currentPage}&per_page=12&query=${this.unsplash.search}&orientation=landscape`, {
        noAuth: true,
        noExtraHeaders: true,
        // headers: {
        //  Authorization: `Client-ID ${this.unsplash.key}`,
        // },
      });

      this.unsplash.loading = false;
      this.unsplash.searchResult.total = data.total;
      this.unsplash.searchResult.total_pages = data.total_pages;
      this.unsplash.searchResult.results = data.results;
    },
    /**
     * Toggle the unsplash modal
     */
    toggleUnsplashModal(bool) {
      if (bool) {
        this.unsplashModal = true;
      } else {
        this.unsplashModal = false;
      }
    },
    inputClick(e) {
      if (this.existing && e.screenX && e.screenX !== 0 && e.screenY && e.screenY !== 0) {
        e.preventDefault();
      }
    },
    reset() {
      this.$el.querySelector('input').value = '';
      this.highlight(false);
    },
    fileEvent(files) {
      if (files.length === 0) return;

      const { maxSize, validFormats, largeFile } = this;

      this.errors = [];

      if (files.length > 1) {
        this.errors.push(this.$t('fileupload.onefile_error'));
      }

      if (!largeFile) {
        if ((files[0].size / 1024 / 1024) > maxSize) {
          this.errors.push(this.$t('fileupload.maxsize_error'));
        }
      }

      let validFormat = false;
      for (let i = 0; i < validFormats.length; i += 1) {
        if (files[0].type.indexOf(validFormats[i]) >= 0) {
          validFormat = true;
        }
      }
      if (!validFormat) {
        this.errors.push(this.$t('fileupload.format_error'));
      }

      if (this.errors.length > 0) {
        this.$el.querySelector('input').value = '';
        this.highlight(false);
        return;
      }

      this.$emit('data', files[0]);
      this.highlighted = false;
    },
    highlight(bool = true) {
      this.highlighted = bool;
    },
  },
  watch: {
    state(state) {
      if (state === 'unload' && this.largeFile) {
        this.$el.querySelector('input').value = '';
        this.highlight(false);
      }
    },
  },
  data() {
    return {
      highlighted: false,
      unsplashModal: false,
      errors: [],
      unsplashKey: process.env.VUE_APP_UNSPLASHKEY,
      unsplash: {
        key: process.env.VUE_APP_UNSPLASHKEY,
        search: '',
        currentPage: 1,
        searchTimer: null,
        loading: false,
        choosing: false,
        searchResult: {
          total: 0,
          total_pages: 0,
          results: [],
        },
      },
    };
  },
  mounted() {},
  beforeDestroy() {},
};
</script>

<style lang="sass" scoped>
.file-upload
  align-items: center
  border: 2px dashed #9fb7c6
  display: flex
  flex-direction: column
  justify-content: center
  padding: 1rem
  position: relative
  &.existing
    border: 0
    input
      cursor: default
  &.full
    position: absolute
    left: 0
    right: 0
    top: 0
    bottom: 0
  & > *
    pointer-events: none
  &.highlighted
    border-color: #4fcf4f
  input
    pointer-events: all
  & > input
    cursor: pointer
    height: 100%
    left: 0
    opacity: 0
    position: absolute
    top: 0
    width: 100%

.upload
  color: #9fb7c6
  font-size: .8rem
  line-height: .8rem
  font-weight: 700
  text-transform: uppercase
</style>

<style lang="sass">
.unsplashModal
  .unsplash-result
    display: flex
    flex-wrap: wrap
  .unsplash-image
    margin: .5rem
    position: relative
    width: calc(50% - 1rem)
    @media (min-width: 730px)
      width: calc(33.3333% - 1rem)
    small
      background-color: rgba(0, 0, 0, .5)
      bottom: 0
      color: white
      display: block
      left: 0
      opacity: 0
      padding: 5px
      position: absolute
      right: 0
      transition: opacity .4s
    img
      display: block
      height: 100%
      max-width: 100%
      width: 100%
    &:hover
      cursor: pointer
      small
        opacity: 1
  .unsplash-pagination
    display: flex
    small
      text-decoration: underline
    small:hover
      cursor: pointer
</style>
